import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.37542 1.89043C4.35371 1.51712 4.67991 1.25 5.00006 1.25C5.32021 1.25 5.64641 1.51712 5.6247 1.89043L5.46875 6.10108C5.46685 6.22275 5.41769 6.33903 5.33152 6.42521C5.24361 6.51311 5.12438 6.5625 5.00006 6.5625C4.87574 6.5625 4.75651 6.51311 4.6686 6.42521C4.58242 6.33903 4.53327 6.22275 4.53137 6.10108L4.37542 1.89043ZM5.00619 1.87962C5.00619 1.87962 5.00616 1.87959 5.00611 1.87953C5.00617 1.87959 5.00619 1.87962 5.00619 1.87962ZM4.99393 1.87962C4.99393 1.87962 4.99395 1.87959 4.99401 1.87953C4.99396 1.87959 4.99393 1.87962 4.99393 1.87962Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.375 8.125C4.375 7.77982 4.65482 7.5 5 7.5C5.34518 7.5 5.625 7.77982 5.625 8.125C5.625 8.47018 5.34518 8.75 5 8.75C4.65482 8.75 4.375 8.47018 4.375 8.125Z",
		fill: "white"
	})]
});
export default SvgExclamation;
